import { render, staticRenderFns } from "./class-schedule.vue?vue&type=template&id=82bc43a2&scoped=true&"
import script from "./class-schedule.vue?vue&type=script&lang=js&"
export * from "./class-schedule.vue?vue&type=script&lang=js&"
import style0 from "./class-schedule.vue?vue&type=style&index=0&id=82bc43a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bc43a2",
  null
  
)

export default component.exports